// {
//     "capacity": number,
//     "operation_efficiency": number,
//     "upcoming_harvest": number,
//     "frames":array [
//         {
//             "amount": number, // number of plants (fake)
//             "plant": "tomato", // konsa plant 
//             "temperature": 23.7, // temp avg
//             "humidity": 75, // humidity avg
//             "luminosity": , // (fake)
//             "moisture", // (fake)
//             "ph", // (fake),
//             “stage”: string, // stage of plant in growth 
//             “days”: number // number of days since plantation
//         },
//     ]
// }

export const markets = [
    "Ahmednagar",
    "Amrawati(Frui & Veg. Market)",
    "Aurangabad",
    "Chandrapur(Ganjwad)",
    "Fruit Market",
    "Jalgaon",
    "Junnar",
    "Kalyan",
    "Karad",
    "Khed(Chakan)",
    "Kolhapur",
    "Mumbai",
    "Nagpur",
    "Nasik",
    "Osmanabad",
    "Palghar",
    "Parbhani",
    "Pune",
    "Pune(Khadiki)",
    "Satara",
    "Shahapur",
    "Shrirampur",
    "Solapur",
    "Tuljapur",
    "Vashi New Mumbai",
    "Aarni",
    "Bhadrawati",
    "Junnar(Otur)",
    "Koregaon",
    "Chalisgaon",
    "Jalana",
    "Sangli(Phale, Bhajipura Market)",
    "Vasai",
    "Aatpadi",
    "Alibagh",
    "Ratnagiri (Nachane)",
    "Kolhapur(Malkapur)",
    "Latur",
    "Maanachar",
    "Rahuri(Songaon)",
    "Pune(Pimpri)",
    "Rahata",
    "Navapur",
    "Pandharpur",
    "Pune(Hadapsar)",
    "Bhivandi",
    "Ulhasnagar",
    "Kolhapur(Laxmipuri)",
    "All India Cottonseed Crushers Association",
    "Kopargaon",
    "Vadgaonpeth",
    "Pen",
    "Sangola",
    "Chopada",
    "Junnar(Alephata)",
    "Mangal Wedha",
    "Rahuri",
    "Washi(Thane Market)",
    "Barshi",
    "Amarawati",
    "Chandrapur",
    "Kamthi",
    "Vai",
    "Ramtek",
    "Akluj",
    "Lasur Station",
    "Islampur",
    "Palthan",
    "Vita",
    "Sinner",
    "Dhule",
    "Murbad",
    "Kalmeshwar",
    "Nashik(Devlali)",
    "Devala",
    "Ghoti",
    "Nagpur(Mahatma Phule Market)",
    "Panvel",
    "Patan",
    "Pimpalgaon",
    "Sangamner",
    "Manmad",
    "Lasalgaon",
    "Akole",
    "Dound",
    "Kurdwadi",
    "Sakri",
    "Chandvad",
    "Kinwat",
    "Junnar(Narayangaon)",
    "Lasalgaon(Niphad)",
    "Jawali",
    "Palus",
    "Shrigonda",
    "Parshiwani",
    "Jaysingpur",
    "Vaijpur",
]